import React, { useMemo } from "react";
import ReactDropdownTreeSelect, { TreeNode } from "react-dropdown-tree-select";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";

interface CustomTexts {
    placeholder?: string;
    noMatches?: string;

    [key: string]: string | undefined;
}

interface CustomReactDropdownTreeSelectProps {
    id?: string;
    name?: string;
    data: TreeNode[];
    value?: TreeNode[];
    onChange?: (currentNode: TreeNode, selectedNodes: TreeNode[]) => void;
    texts?: CustomTexts;
    showDropdown?: "initial" | "always";
    className?: string;
    showPartiallySelected?: boolean;
    keepOpenOnSelect?: boolean;
    onFocus?: () => void;
    onBlur?: () => void;
    disabled?: boolean;
}

const CustomReactDropdownTreeSelect: React.FC<CustomReactDropdownTreeSelectProps> = ({
    id,
    name,
    data,
    onChange,
    texts,
    showDropdown,
    className,
    showPartiallySelected = true,
    keepOpenOnSelect = true,
    onFocus,
    onBlur,
    disabled,
}) => {
    const { t } = useTranslation();
    const { setFieldValue, setFieldTouched } = useFormikContext<any>();

    const mergedTexts: CustomTexts = useMemo(
        () => ({
            placeholder: t("Search dishes"),
            noMatches: t("Nothing found"),
            ...texts,
        }),
        [texts, t]
    );

    const handleChange = (currentNode: TreeNode, selectedNodes: TreeNode[]) => {
        const ids = selectedNodes.map((node) => Number(node.value));

        setFieldValue(name, ids);

        if (onChange) {
            onChange(currentNode, selectedNodes);
        }
    };

    const handleBlur = () => {
        setFieldTouched(name, true);
        onBlur?.();
    };

    return (
        <>
            <ReactDropdownTreeSelect
                id={id}
                data={data}
                onChange={handleChange}
                texts={mergedTexts}
                showDropdown={showDropdown}
                className={`custom-dropdown-tree-select ${className ?? ""}`}
                showPartiallySelected={showPartiallySelected}
                keepOpenOnSelect={keepOpenOnSelect}
                onFocus={onFocus}
                onBlur={handleBlur}
                disabled={disabled}
            />
        </>
    );
};

export default CustomReactDropdownTreeSelect;
